import { create } from 'zustand';
import { GameState, GameType } from '../types';
import { resolveAvatarUrl, AVATAR_MAP } from '../lib/utils';

interface GameStore {
  gameState: GameState | null;
  gameType: GameType;
  inGame: boolean;
  setGameState: (state: GameState | null) => void;
  setGameType: (type: GameType) => void;
  setInGame: (inGame: boolean) => void;
}

export const useGameStore = create<GameStore>((set) => ({
  gameState: null,
  gameType: 'pisti',
  inGame: false,
  setGameState: (state) => set({ gameState: state }),
  setGameType: (type) => set({ gameType: type }),
  setInGame: (inGame) => set({ inGame }),
}));

// Additional store for UI/User settings
interface UserStore {
  myId: string;
  shortId: string;
  userName: string;
  userAvatar: string;
  language: 'tr' | 'en';
  stats: { gamesPlayed: number; gamesWon: number; totalScore: number };
  setMyId: (id: string) => void;
  setShortId: (id: string) => void;
  setUserName: (name: string) => void;
  setUserAvatar: (avatar: string) => void;
  setLanguage: (lang: 'tr' | 'en') => void;
  setStats: (stats: { gamesPlayed: number; gamesWon: number; totalScore: number }) => void;
}

export const useUserStore = create<UserStore>((set) => ({
  myId: '',
  shortId: '',
  userName: localStorage.getItem('userName') || 'Oyuncu 1',
  userAvatar: resolveAvatarUrl(localStorage.getItem('userAvatar') || 'ahmet'),
  language: (localStorage.getItem('language') as 'tr' | 'en') || 'tr',
  stats: JSON.parse(localStorage.getItem('playerStats') || '{"gamesPlayed":0,"gamesWon":0,"totalScore":0}'),
  setMyId: (id) => set({ myId: id }),
  setShortId: (id) => set({ shortId: id }),
  setUserName: (name) => {
    localStorage.setItem('userName', name);
    set({ userName: name });
  },
  setUserAvatar: (avatar) => {
    localStorage.setItem('userAvatar', avatar);
    set({ userAvatar: avatar });
  },
  setLanguage: (lang) => {
    localStorage.setItem('language', lang);
    set({ language: lang });
  },
  setStats: (stats) => {
    localStorage.setItem('playerStats', JSON.stringify(stats));
    set({ stats });
  },
}));
